import { Grid, Paper, Stack, TextField, Typography } from "@mui/material";
import React from "react";
import Editor from "react-simple-code-editor";
import { highlight, languages } from 'prismjs/components/prism-core';
// import 'prismjs/components/prism-javascript';
import Service from "../../../../util/Service";
const BmcStatusBusinessTask = React.forwardRef((props, ref) => {
    const { item, processo } = props;

    const [status, setStatus] = React.useState('');
    React.useImperativeHandle(ref, () => ({
        childMethod() {
            salva();
        }
    }))

    React.useEffect(() => {
        const tk = processo.lstTask.find(t => t.idTask === item.id);
        // console.log(tk);
        if (tk) {
            setStatus(tk?.status);
        } else {
            //buscaCodigo('BmcAnexo.txt');
        }
    }, []);
    /* function buscaCodigo(exemplo) {
        if (!exemplo) return;
        Service.FETCH("/api/bpmn/buscaCodigoExemplo/" + exemplo)
            .then(r => {
                setCode(r)
            });
    }; */

    function salva() {
        console.log('>>>salva from Filho<<<');

        const dado = {
            idTask: item.id,
            idProcesso: processo.id,
            taskType: item.type,
            tipo: 'BMC-STATUS',
            status: status,

        }

        Service.POST("/api/bpmn/salvarTaskDoProcesso", dado).then(resp => {
            console.log(resp);
        }).catch(error => {
            console.error(error)
        })
        console.log(dado);
    }
    return (
        <Grid container spacing={2}>
            <Grid size={6}>
                <Stack spacing={2}>
                    <Typography>Fluxo de pos-criação do WO no BMC, usado para retirar o status anterior. </Typography>
                </Stack>
            </Grid>


            <Grid size={12}>
                <Stack spacing={2}>
                    <TextField id="timeOut" label="Status" variant="outlined" value={status} onChange={(e) => setStatus(e.target.value)} />
                    {/*  
                               
                               <TextField id="outlined-basic" label="Sucesso" variant="outlined" value={sucesso} onChange={(e) => setSucesso(e.target.value)}/>
                                <TextField id="outlined-basic" label="Falha" variant="outlined" value={falha} onChange={(e) => setFalha(e.target.value)} /> */}

                </Stack>
            </Grid>


        </Grid>
    )

})

export default BmcStatusBusinessTask;